import React from 'react';
import './style.css';

const ErrorText = ({ children }) => (
  <div className="error-block">{children}</div>
);

export default ErrorText;
